import { trans } from '@/lib/calendesk-js-library/prototypes/trans'

export default () => {
  document.title = `${trans('wb_website_builder')} | Calendesk`
}
